
<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row mt-1" v-for="(el, index) in getData()">
        <div class="col-12">
          <input-select3 class="mt-1" v-model="el.TypeName" v-bind:options="['Avg','Group','Count']" />
          <input-select3 class="ml-1 mt-1" v-model="el.Source" v-bind:options="['Priority','Time','User']" />
          <input type="text" class="form-control ml-1 px-1 col-4" v-model="el.Name" style="display:inline-table;font-size:12px;line-height:20px;height:38px;" />
          <input-color-selector v-model="el.Color"></input-color-selector>
          <a href="#" @click="remove(el)"><i class="icon-subtract"></i></a>

        </div>
        <div class="col-12 pl-3">
          <series-element v-bind:showadd="allownesting" v-bind:value="el.Series"></series-element>
        </div>
      </div>
     
    </div>
    <series-add v-if="showadd == true" @add="addItem" />
  </div>
</template>

<script>

  export default {
    name: 'series-element',
    components: {
    },
    data(){
      return {
        contentJson: "",
        elements:['olle','bertil']
      }
    },
    props: {
      value: {
        required: false,
        type: Array,
        default() {
          return []
        }
      },
      list: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
      showadd: {
        required: false,
        type: Boolean,
        default() {
          return false
        }
      },
      showcontrols: {
        required: false,
        type: Boolean,
        default() {
          return false
        }
      },
      allownesting: {
        required: false,
        type: Boolean,
        default() {
          return false
        }
      },
    },
    methods: {
      getJsonData() {
        this.contentJson = JSON.stringify(this.realValue);
        return this.contentJson;
      },
      setJsonData() {
        this.value = JSON.parse(this.contentJson);
      },
      remove(el) {
        var elements = this.value;
        var itemIndex = -1;
        for (var i = 0; i < elements.length; i++) {
          if (elements[i] == el) {
            itemIndex = i;
          }
        }
        this.realValue.splice(itemIndex, 1);
        this.$emit('change');
      },
      addChildItem(el) {
        if (!this.realValue.Series || this.realValue.Series == null)
          this.realValue.Series = [];
        this.realValue.Series.push(el);
        this.$forceUpdate();
      },
      addItem(el) {
        el.Series = [];
        this.realValue.push(el);
        this.$forceUpdate();
        this.$emit('change');
      },
      changed(el) {
        this.$forceUpdate();
        this.$emit('change');
      },
      setData(data) {
        this.value = data;
        this.$forceUpdate();
      },
      
      getData(data) {
        return this.value;
      },
      handleRefresh(val) {
        //this.elements = this.getFlat(val.Elements);

        //Vue.set(this, "elements", this.elements);
        //this.$forceUpdate();
      },
    },
  created() {
    //this.$root.$on('procedure_refresh', this.handleRefresh);
  },
  mounted() {

    },

    computed: {
      /*
      elements: {
        get() {
          var proc = this.procedure;
          var els = this.getFlat(proc.Elements);
          return els;
        },
      },
      */
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 3");
          this.$store.commit('saveprocedure', value)
        }
      },
      realValue() {
        return this.value;
      },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/statistics/series-element.vue